import { createAction, props } from '@ngrx/store';
import {
  ExportValidation,
  StartExportResponse,
  VeridionExport,
  ExportListPagination
} from '../../services/veridion-export.service';

// ============================================
// Validate Export Credits Actions
// ============================================
export const validateExportCredits = createAction(
  '[Veridion Export] Validate Credits',
  props<{ totalRecords: number; pageSize?: number }>()
);

export const validateExportCreditsSuccess = createAction(
  '[Veridion Export] Validate Credits Success',
  props<{ validation: ExportValidation }>()
);

export const validateExportCreditsFailure = createAction(
  '[Veridion Export] Validate Credits Failure',
  props<{ error: any }>()
);

// ============================================
// Start Export Actions
// ============================================
export const startVeridionExport = createAction(
  '[Veridion Export] Start Export',
  props<{ filters: any[]; totalRecords: number; pageSize?: number }>()
);

export const startVeridionExportSuccess = createAction(
  '[Veridion Export] Start Export Success',
  props<{ result: StartExportResponse }>()
);

export const startVeridionExportFailure = createAction(
  '[Veridion Export] Start Export Failure',
  props<{ error: any }>()
);

// ============================================
// Load Exports List Actions
// ============================================
export const loadExports = createAction(
  '[Veridion Export] Load Exports',
  props<{ status?: string; page?: number; perPage?: number }>()
);

export const loadExportsSuccess = createAction(
  '[Veridion Export] Load Exports Success',
  props<{ exports: VeridionExport[]; pagination: ExportListPagination }>()
);

export const loadExportsFailure = createAction(
  '[Veridion Export] Load Exports Failure',
  props<{ error: any }>()
);

// ============================================
// Download Export Actions
// ============================================
export const downloadExport = createAction(
  '[Veridion Export] Download Export',
  props<{ exportId: number; fileName?: string }>()
);

export const downloadExportSuccess = createAction(
  '[Veridion Export] Download Export Success',
  props<{ exportId: number }>()
);

export const downloadExportFailure = createAction(
  '[Veridion Export] Download Export Failure',
  props<{ exportId: number; error: any }>()
);

// ============================================
// Reset Actions
// ============================================
export const resetExportState = createAction(
  '[Veridion Export] Reset State'
);

export const resetValidationState = createAction(
  '[Veridion Export] Reset Validation State'
);

export const resetStartExportState = createAction(
  '[Veridion Export] Reset Start Export State'
);
